export function haveSameContents<T, N>(a: T[], b: N[]) {
	for (const v of new Set([...a, ...b]))
		if (a.filter((e) => e === v).length !== b.filter((e) => e === v).length) return false;
	return true;
}
